__turbopack_context__.v({
  "blocksBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__blocksBackgroundColor",
  "blocksFontColor": "SchoolsDropdown-module-scss-module__JXKucW__blocksFontColor",
  "buttonTextContainer": "SchoolsDropdown-module-scss-module__JXKucW__buttonTextContainer",
  "container": "SchoolsDropdown-module-scss-module__JXKucW__container",
  "faIcon": "SchoolsDropdown-module-scss-module__JXKucW__faIcon",
  "menuItem": "SchoolsDropdown-module-scss-module__JXKucW__menuItem",
  "mobileContainer": "SchoolsDropdown-module-scss-module__JXKucW__mobileContainer",
  "mobileContent": "SchoolsDropdown-module-scss-module__JXKucW__mobileContent",
  "secondaryNavBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__secondaryNavBackgroundColor",
  "slideDown": "SchoolsDropdown-module-scss-module__JXKucW__slideDown",
  "slideUp": "SchoolsDropdown-module-scss-module__JXKucW__slideUp",
  "themeBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__themeBackgroundColor",
  "themeFontColor": "SchoolsDropdown-module-scss-module__JXKucW__themeFontColor",
  "trigger": "SchoolsDropdown-module-scss-module__JXKucW__trigger",
  "triggerSticky": "SchoolsDropdown-module-scss-module__JXKucW__triggerSticky",
});
